<template>
  <div id="detailed">
    <header>
      <el-button type="primary" icon="el-icon-arrow-left" style="float: left" circle @click="goBack"></el-button>
      <div style="color:#ffffff">{{titleName}}</div>
      <div class="header-device">
        <div>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
              <p style="margin-top: -1%;color: #ffffff">{{$t("mobileDevice")}}：</p>{{deviceDefaultName}} <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
            <el-dropdown-menu style="max-height: 150px;max-width: 150px; overflow: auto" slot="dropdown">
              <el-dropdown-item v-for="(item, index) in deviceBoards" :key="index" :command="item">{{item.name}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </header>
    <div class="main">
      <latest-data ref="latestData" v-show="latestFlg"/>
      <history-data ref="historyData" v-show="historyFlg"/>
      <warn-data ref="warnData" v-show="warningFlg"/>
      <fx-set-data ref="fxSetData" v-show="fxSetFlg"/>
    </div>
    <footer>
      <div :class="index == 1 ? 'bottom_icon_1':'bottom_icon'" @click="newDate(1)">
        <img :src="index == 1 ? require('./img/new.png') : require('./img/new1.png')">
        <p style="margin-top: -10%">{{$t("mobileTelemetry")}}</p>
      </div>
      <div :class="index == 2 ? 'bottom_icon_2':'bottom_icon'" @click="historyData(2)">
        <img :src="index == 2 ? require('./img/history.png') : require('./img/history1.png')">
        <p style="margin-top: -10%">{{$t("mobileHistory")}}</p>
      </div>
      <div :class="index == 3 ? 'bottom_icon_3':'bottom_icon'" @click="warnData(3)">
        <img :src="index == 3 ? require('./img/warn.png') : require('./img/warn1.png')">
        <p style="margin-top: -10%">{{$t("mobileWarn")}}</p>
      </div>
      <div :class="index == 4 ? 'bottom_icon_4':'bottom_icon'" @click="fxDataSet(4)" v-if = fxSetShow>
        <img :src="index == 4 ? require('./img/fxSet.png') : require('./img/fxSet1.png')">
        <p style="margin-top: -10%">控制</p>
      </div>
    </footer>
  </div>
</template>

<script>
  import latestData from "./latestData";
  import historyData from "./historyData";
  import warnData from "./warnData";
  import fxSetData from "./fxSetData";
  import {
    getAttributesClient, getAttributesServer, getAttributesShared,
    getCredentials,
    getCustomerDevice,
    getDeviceKey,
    getDevicesInfo,
    getDeviceValue
  } from "../untils/api/home";
  import router from "../router";

  export default {
    name: 'mobileDetailed',
    components: {
      fxSetData,
      latestData,
      historyData,
      warnData
    },
    data() {
      return {
        deviceDefaultId: '',
        deviceDefaultName: '',
        deviceBoards: [],
        latestFlg: true,
        historyFlg: false,
        warningFlg: false,
        fxSetFlg: false,
        fxSetShow: false,
        titleName: this.$t("mobileLatest"),
        index: 1,
        upList: [],
        lowList: [],
        oldListStr: '',
        time: null,
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ?  this.$commonFun.deciphering(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ?  this.$commonFun.deciphering(localStorage.getItem('customerId')) : this.$route.params.customerId;
      //用户为租户管理员
      if (authority === 'TENANT_ADMIN') {
        //获取设备列表 存放在数组
        getDevicesInfo().then(response => {
          //设置设备列表
          this.setDeviceInfo(response);
        }).catch(error => {
          console.log("error", error)
        })
      } else {
        //用户为租户
        getCustomerDevice(customerId).then(response => {
          //设置设备列表
          this.setDeviceInfo(response);
        }).catch(error => {
          console.log("error", error);
        })
      }

      // this.$alert('尊敬的客户，我们将于2024年12月31日删除2024年11月4日之前的历史数据，请有需求的客户请及时存储。给您带来的不便，深感抱歉！', '', {
      //   confirmButtonText: '确定',
      // });

  //     this.msg = this.$message({
  //       showClose: true,
  //       type: 'warning',
  //       dangerouslyUseHTMLString: true, // 允许HTML
  //       message: `
  //   <div style="
  //     min-width: 300px;
  //     padding: 15px;
  //     line-height: 1.8;
  //     text-align: left;
  //   ">
  //     <div style="margin-bottom: 10px; font-weight: bold;">尊敬的客户：</div>
  //     <div style="margin: 8px 0;">我们将于<strong>2025年7月4日</strong>删除</div>
  //     <div style="margin: 8px 0;"><strong>2025年7月4日之前</strong>的历史数据</div>
  //     <div style="margin: 12px 0 0; color: #f56c6c;">请有需求的客户及时存储</div>
  //     <div style="margin-top: 12px;">给您带来的不便，深感抱歉！</div>
  //   </div>
  // `,
  //       duration: 10000,
  //       offset: 200
  //     })
    },

    beforeDestroy() {
      clearInterval(this.time);
      this.time = null;
      // if(this.msg != null) {
      //   this.msg.close();
      //   this.msg = null;
      // }
    },

    methods: {
      /**
       * 获取选中设备的id 以及名称
       * @param command
       */
      handleCommand(command) {
        //选中设备id
        this.deviceDefaultId = command.id;
        //选中设备的名称
        this.deviceDefaultName = command.name;
        localStorage.setItem('upLowList',null);
        clearInterval(this.time);
        this.time = null;
        this.$refs.warnData.getMobileCredentialsInfo(command.id);
        this.$refs.fxSetData.fxCredentialsInfo(command.id);
        //获取选中设备信息
        this.getDeviceInfo();
      },

      /**
       * 设置设备列表
       * @param response
       */
      setDeviceInfo(response) {
        for (let i = 0; i < response.data.length; i++) {
          let deviceOption = {};
          deviceOption.id = response.data[i].id.id;
          deviceOption.name = response.data[i].name;
          this.deviceBoards.push(deviceOption);
        }

        //设置默认选中的设备
        this.deviceDefaultId = this.deviceBoards[0].id;
        this.deviceDefaultName = this.deviceBoards[0].name;
        this.$refs.warnData.getMobileCredentialsInfo(this.deviceBoards[0].id);
        this.$refs.fxSetData.fxCredentialsInfo(this.deviceBoards[0].id);
        //获取选中设备的信息
        this.getDeviceInfo();
      },

      /**
       * 获取选中设备信息
       */
      getDeviceInfo() {
        //访问api获取设备信息
        getCredentials(this.deviceDefaultId).then(response => {
          this.getCredentialInfos(response.deviceId);
          //获取选中设备的最新key
          this.getDeviceKeys(response.deviceId);
          this.getLevelRefer(response.deviceId);
          this.getFxRefer(response.deviceId);
          this.$refs.latestData.getMobileVedioShare(response.deviceId);
        }).catch(error => {
          console.log("error", error)
        });

        this.time = window.setInterval(() => {
          setTimeout(() => {
            getCredentials(this.deviceDefaultId).then(response => {
              //获取选中设备的最新key
              this.getDeviceKeys(response.deviceId);
            }).catch(error => {
              console.log("error", error)
            });
          },0)
        }, 1000 * 60)
      },

      /**
       * 获取选中设备信息
       * @param deviceId
       */
      getCredentialInfos(deviceId) {
        this.upList = [];
        this.lowList = [];
        //访问api获取设备信息
        getCredentials(deviceId.id).then(response => {
          //获取客户端遥测数据上下限值
          this.getThresholdInfos(response.credentialsId);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取客户端遥测数据上下限值
       * @param credentialsId
       */
      getThresholdInfos(credentialsId) {
        //访问api
        getAttributesClient(credentialsId).then(response => {
          for (let obj in response.client) {
            if (obj.substring(obj.length - 3) === '_up') {
              //获取遥测数据上限值
              let upJson = {};
              upJson.name = obj.substring(0, obj.length - 3);
              upJson.value = response.client[obj];
              this.upList.push(upJson);
            } else if (obj.substring(obj.length - 4) === '_low') {
              //获取遥测数据下限值
              let lowJson = {};
              lowJson.name = obj.substring(0, obj.length - 4);
              lowJson.value = response.client[obj];
              this.lowList.push(lowJson);
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取选中设备的最新key
       * @param deviceId
       */
      getDeviceKeys(deviceId) {
        //访问api 获取设备key
        getDeviceKey(deviceId.entityType, deviceId.id).then(response => {
          let deviceKey = '';
          let pattern = /^[A-Za-z0-9.-_-]+$/;
          //判断key是否存在
          //response.length === 0 ? deviceKey = 'false' : deviceKey = '';
          //key 存在遍历取出 转成字符串
          for (let i = 0; i <= response.length - 1; i++) {
            if (pattern.test(response[i])) {
              i === response.length - 1 ? deviceKey += response[i] : deviceKey += response[i] + ','
            }
          }
          //获取选中设备的最新value
          this.getDeviceValues(deviceId, deviceKey);
          //将最新遥测数据传到警告画面
          this.$refs.warnData.getKeysInfos(deviceId,response);
          this.$refs.historyData.getSelectKeys(response,deviceId);
        }).catch(error => {
          console.log("error", error);
        })
      },


      getLevelRefer(deviceId) {
        localStorage.setItem('levelRefer', 0);
        localStorage.setItem('snowRefer', 0);
        localStorage.setItem("emptyHRefer", 0);
        localStorage.setItem('noiseRefer', 0);
        localStorage.setItem("CODJson", null);
        localStorage.setItem("waterFlg", null);
        localStorage.setItem("cumFlow", null);
        getAttributesShared(deviceId.entityType, deviceId.id).then(response => {
          for(let i = 0; i < response.length; i++){
            if(response[i].key === "level_refer") {
              localStorage.setItem('levelRefer', response[i].value);
            } else if(response[i].key === "snow_refer") {
              localStorage.setItem('snowRefer', response[i].value);
            } else if(response[i].key == 'emptyH_refer') {
              localStorage.setItem("emptyHRefer", response[i].value);
            } else if(response[i].key == 'noise_refer') {
              localStorage.setItem("noiseRefer", response[i].value);
            } else if(response[i].key == 'CODJson'){
              localStorage.setItem("CODJson", response[i].value);
            } else if(response[i].key == 'waterFlg') {
              localStorage.setItem("waterFlg", response[i].value);
            } else if(response[i].key == 'cumFlow') {
              localStorage.setItem("cumFlow", response[i].value);
            }
          }
        })
      },

      getFxRefer(deviceId) {
        localStorage.setItem("fx", null);
        localStorage.setItem("HI", null);
        localStorage.setItem("TG", null);
        localStorage.setItem("WD", null);
        getAttributesServer(deviceId.entityType, deviceId.id).then(response => {
          if(response.length == 0 &&  this.fxSetShow == true && this.fxSetFlg == true) {
            this.fxSetShow = false;
            this.newDate(1);
            return;
          }
          for(let i = 0; i < response.length; i++){
            if(response[i].key == 'fx') {
              this.fxSetShow  = true;
              localStorage.setItem("fx", response[i].value);
            } else if(response[i].key == 'HI') {
              localStorage.setItem("HI", response[i].value);
            } else if(response[i].key == 'TG') {
              localStorage.setItem("TG", response[i].value);
            } else if(response[i].key == 'WD') {
              localStorage.setItem("WD", response[i].value);
            }
            if(i == response.length - 1) {
              if(localStorage.getItem("fx") === "null") {
                this.fxSetShow = false;
                this.newDate(1);
              }
            }
          }

        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 获取选中设备的最新value
       * @param deviceId
       * @param deviceKey
       */
      getDeviceValues(deviceId, deviceKey) {
        //key存在访问api
        getDeviceValue(deviceId.entityType, deviceId.id, deviceKey).then(response => {
          let newList = eval(localStorage.getItem("upLowList"));//获取本地设置的警报
          if(localStorage.getItem('waterFlg') == "water") {
            response["Amnitro"][0].value = this.calculateWater(0,8,parseFloat(response["Amnitro"][0].value)).toFixed(2);
            response["dissolvedoxygen"][0].value = this.calculateWater(2, 10, parseFloat(response["dissolvedoxygen"][0].value)).toFixed(2);
            response["Opacity"][0].value = this.calculateWater(251, 1000, parseFloat(response["Opacity"][0].value)).toFixed(0);
            response["oRp"][0].value = this.calculateWater(50, 500, parseFloat(response["oRp"][0].value)).toFixed(0);
          }
          //本地警报为null 或 本地警报与上次警报一致
          if(newList === null || this.oldListStr === JSON.stringify(newList)){
            this.setItemListInfo(this.upList, this.lowList, response);
            this.oldListStr = JSON.stringify(JSON.stringify(newList));
          } else {
            //本地警报不为null 或 本地警报与上次警报不一致
            this.getNewUpLow(newList,response);
            this.oldListStr = JSON.stringify(JSON.stringify(newList));
          }
          // this.setItemListInfo(this.upList, this.lowList, response);
          // this.$refs.latestData.getDeviceItems(response, this.upList, this.lowList);
          // this.$refs.latestData.getMobileVedioShare(deviceId);
        }).catch(error => {
          console.log("error", error)
        })
      },

      /**
       * 拆分最新警告值
       * @param newList  最新警告值
       * @param response  最新遥测值
       */
      getNewUpLow(newList,response) {
        let newUpList = []; //最新最低报警值
        let newLowList = [];//最新最高报警值
        for(let i = 0; i < newList.length; i++) {
          for (let obj in newList[i]) {
            if (obj.substring(obj.length - 3) === '_up') {
              let upJson = {};
              upJson.name = obj.substring(0, obj.length - 3);
              upJson.value = parseFloat(newList[i][obj]);
              newUpList.push(upJson);
            } else if (obj.substring(obj.length - 4) === '_low') {
              //获取遥测数据下限值
              let lowJson = {};
              lowJson.name = obj.substring(0, obj.length - 4);
              lowJson.value = parseFloat(newList[i][obj]);
              newLowList.push(lowJson)
            }
          }
        }
        //将当前的警报值设置为最新警报值
        this.setNewWarnList(newUpList, newLowList, response);
      },

      /**
       * 将当前的警报值设置为最新警报值
       * @param newUpList
       * @param newLowList
       * @param response
       */
      setNewWarnList(newUpList, newLowList, response) {
        //将当前的警报上限值设置为最新警报值
        for(let i in newUpList){
          let upFlg = false;
          for(let j in this.upList){
            if(this.upList[j].name === newUpList[i].name){
              this.upList[j].value = parseFloat(newUpList[i].value);
              upFlg = true;
            }
          }
          if(!upFlg){
            this.upList.push(newUpList[i]);
          }
        }

        //将当前的警报下限值设置为最新警报值
        for(let i in newLowList){
          let lowFlg = false;
          for(let j in this.lowList){
            if(this.lowList[j].name === newLowList[i].name){
              this.lowList[j].value = parseFloat(newLowList[i].value);
              lowFlg = true;
            }
          }
          if(!lowFlg) {
            this.lowList.push(newLowList[i]);
          }
        }
        this.setItemListInfo(this.upList, this.lowList, response);
      },

      /**
       * 筛选出超过上限或者低于下线的值
       * @param upList
       * @param lowList
       * @param latestResponse
       */
      setItemListInfo(upList, lowList, latestResponse){
        let snowRefer = localStorage.getItem('snowRefer');
        let levelRefer = localStorage.getItem('levelRefer');//获取设置的水位值
        let noiseRefer = localStorage.getItem('noiseRefer');

        let amnitroResult = 0;
        if(latestResponse.hasOwnProperty('ammoniaIon')) {
          if(latestResponse.hasOwnProperty('waterPH')) {
            let amnitro = parseFloat(latestResponse['ammoniaIon'][0].value);
            let waterPH = parseFloat(latestResponse['waterPH'][0].value);
            if(latestResponse.hasOwnProperty('waterT')){
              let waterT = parseFloat(latestResponse['waterT'][0].value);
              let result = amnitro * Math.pow(10, waterPH - (-0.032 * waterT + 10.042)) + amnitro;
              amnitroResult = parseFloat(result).toFixed(2);
            } else {
              let result = amnitro * Math.pow(10, (waterPH - 9.25)) + amnitro;
              amnitroResult = parseFloat(result).toFixed(2);
            }
          } else {
            amnitroResult = parseFloat(latestResponse['ammoniaIon'][0].value)
          }
        } else {
          amnitroResult = 0;
        }

        let warnList = [];
        for (let obj in latestResponse) {
          for (let up in upList) {
            if((obj === upList[up].name) && (obj == "snowHeight" || obj == "snowheight") && (Math.abs(parseFloat(snowRefer) +  parseFloat(latestResponse[obj][0].value)) > parseFloat(upList[up].value))) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if((obj === upList[up].name) && (obj == "level" || obj == "Rwater" || obj == "waterlevel") && (Math.abs(parseFloat(levelRefer) +  parseFloat(latestResponse[obj][0].value)) > parseFloat(upList[up].value))) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if((obj === upList[up].name) && (obj == "noise" || obj == "noi" || obj == "noise1" || obj == 'noise2') && (Math.abs(parseFloat(noiseRefer) +  parseFloat(latestResponse[obj][0].value)) > parseFloat(upList[up].value))) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if((obj === upList[up].name) && (obj == "ammoniaIon")  && (parseFloat(amnitroResult) > parseFloat(upList[up].value))) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if((obj === upList[up].name) && (obj == "flowNum") && (parseFloat(latestResponse[obj][0].value) * 6.28) > parseFloat(upList[up].value)) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if((obj === upList[up].name) && (obj == "Rday1") && (parseFloat(latestResponse[obj][0].value) * 0.36) > parseFloat(upList[up].value)) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            } else if ((obj === upList[up].name) && (obj != "snowHeight") && (obj != "snowheight") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel") && (obj != "noise")
              && (obj != 'noi')  && (obj != 'noise1') && (obj != 'noise2') && (obj != 'ammoniaIon') && (obj != 'flowNum') && (obj != 'Rday1') && (parseFloat(latestResponse[obj][0].value) > parseFloat(upList[up].value))) {
              let upJson = {};
              upJson.name = obj;
              upJson.flg = 'up';
              warnList.push(upJson);
            }
          }
          for (let low in lowList) {
            if((obj === lowList[low].name) && (obj == "snowHeight" || obj == "snowheight") && (Math.abs(parseFloat(snowRefer) + parseFloat(latestResponse[obj][0].value))  < parseFloat(lowList[low].value))) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if((obj === lowList[low].name) &&  (obj == "level" || obj == "Rwater" || obj == "waterlevel") && (Math.abs(parseFloat(levelRefer) + parseFloat(latestResponse[obj][0].value))  < parseFloat(lowList[low].value))) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if((obj === lowList[low].name) &&  (obj == "noise" || obj == "noi" || obj == "noise1" || obj == 'noise2') && (Math.abs(parseFloat(noiseRefer) + parseFloat(latestResponse[obj][0].value))  < parseFloat(lowList[low].value))) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if((obj === lowList[low].name) && (obj == "ammoniaIon") && (parseFloat(amnitroResult) < parseFloat(lowList[low].value))) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if((obj === lowList[low].name) &&  (obj == "flowNum" ) && (parseFloat(latestResponse[obj][0].value) * 6.28)  < parseFloat(lowList[low].value)) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if((obj === lowList[low].name) &&  (obj == "Rday1" ) && (parseFloat(latestResponse[obj][0].value) * 0.36)  < parseFloat(lowList[low].value)) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            } else if (obj === lowList[low].name && (obj != "snowHeight") && (obj != "snowheight") && (obj != "level") && (obj != "Rwater") && (obj != "waterlevel") && (obj != "noise")
              && (obj != 'noi')  && (obj != 'noise1') && (obj != 'noise2') && (obj != 'ammoniaIon') && (obj != 'flowNum') && (obj != 'Rday1') && (parseFloat(latestResponse[obj][0].value) < parseFloat(lowList[low].value))) {
              let lowJson = {};
              lowJson.name = obj;
              lowJson.flg = 'low';
              warnList.push(lowJson);
            }
          }
        }
        this.$refs.latestData.getDeviceItems(latestResponse, warnList);
      },

      calculateWater(min, max, value) {
        value = Math.abs(value);
        if(value == 0) value += 1;
        if (value >= min && value <= max) {
          return value; // 直接返回原值
        }

        if (value < min) {
          let multiplier = 2;
          while (value < min) {
            value *= multiplier;
            if (value >= min) break;
            multiplier = Math.min(multiplier + 1, max / min); // 限制 multiplier 递增幅度
          }
        } else if (value > max) {
          let divisor = 2;
          while (value > max) {
            value /= divisor;
            if (value <= max) break;
            divisor = Math.min(divisor + 1, max / min); // 限制 divisor 递增幅度
          }
        }

        return Math.min(Math.max(value, min), max); // 确保最终值在区间内
      },

      /**
       * 最新遥测
       * @param i
       */
      newDate(i) {
        this.latestFlg = true;
        this.historyFlg = false;
        this.warningFlg = false;
        this.fxSetFlg = false;
        this.titleName = this.$t("mobileLatest");
        this.index = i;
      },

      /**
       * 历史遥测数据
       * @param i
       */
      historyData(i) {
        this.latestFlg = false;
        this.historyFlg = true;
        this.warningFlg = false;
        this.fxSetFlg = false;
        this.titleName = this.$t("mobileHistoryData");
        this.index = i;
        this.$refs.warnData.btnCancel();
      },

      /**
       * 警告数据
       * @param i
       */
      warnData(i) {
        this.latestFlg = false;
        this.historyFlg = false;
        this.warningFlg = true;
        this.fxSetFlg = false;
        this.titleName = this.$t("mobileWarnSet");
        this.index = i;
        this.$refs.warnData.btnCancel();
      },

      fxDataSet(i) {
        this.latestFlg = false;
        this.historyFlg = false;
        this.warningFlg = false;
        this.fxSetFlg = true;
        this.titleName = "参数设置";
        this.index = i;
      },

      goBack() {
        let local = localStorage.getItem('locale');
        clearInterval(this.time);
        this.time = null;
        localStorage.clear();
        localStorage.setItem('locale',local)
        // if(this.msg != null) {
        //   this.msg.close();
        //   this.msg = null;
        // }
        // this.$router.go(-1)
        router.replace('/')
      },
    }
  }
</script>

<style lang="less" scoped>
  @media screen and (max-width: 500px) {
    #detailed {
      width: 100%;
      height:100%;
      margin:0;
      padding:0;
      background-color: #34455f;//#39383f  #0089cc  #37477E
    }

    header {
      width:100%;
      height:17vw;
      font-size: 6vw;
      position:absolute;
      z-index:5;
      top:0;
      text-align:center;
      color: #ffffff;
      padding-top: 2vw;
      .header-device {
        margin-bottom: 3%;
        height: 5%;
        width: 100%;
        color: white;
        text-align: center;
        font-size: 4vw;
        margin-top: 1%
      }
      .el-button--primary {
        background-color: #34455f; //#39383f  #0089cc  121423
        font-size: 7vw;
        border: none;
        color: #ffffff;
      }
    }
    .main {
      background:#1c2735;//#334765 #0089cc #0d0c0f #39383f
      width:100%;
      /*overflow:auto;*/
      top:17vw;
      position:absolute;
      z-index:10;
      bottom:10vw;
      color: #ffffff;

      .main-content{
        width: 95%;
        height: 10vw;
        display: flex;
        justify-content: space-between;
        margin-top: 1%;
        margin-left:2.5%;
        text-align: center;
        font-size: 3.5vw;
      }
    }

    footer {
      height:12vw;
      width: 80%;
      position:absolute;
      z-index:200;
      bottom:0;
      text-align:center;
      display: flex;
      justify-content: space-between;
      margin-left: 10%;

      .bottom_icon {
        width: 9.5%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #dbdbdb;
      }

      .bottom_icon_1 {
        width: 9.5%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd;//#3c66f2  #15FEDA
      }

      .bottom_icon_2 {
        width: 9.5%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd;//#1296db  #3c66f2
      }

      .bottom_icon_3 {
        width: 9.5%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd; // #FF0000  #3c66f2
      }

      .bottom_icon_4 {
        width: 9.5%;
        height: 10%;
        margin-top: 2%;
        font-size: 3vw;
        color: #83e2fd; // #FF0000  #3c66f2
      }
    }

    .el-dropdown-link {
      cursor: pointer;
      color: #83e2fd; //#1890ff  #15FEDA #3e57ae
      font-size: 4vw;
      display: flex;
      justify-content: space-between;
    }

    .el-icon-arrow-down {
      font-size: 3.5vw;
    }

    .el-dropdown-menu__item {
      line-height: 150px;
      font-size: 4vw;
    }

    .el-icon--right {
      margin-top: 23px;
    }
  }
</style>

<!--<style>-->
<!--   .el-message-box {-->
<!--     width: 50vw;-->
<!--     height: 28vw;-->
<!--  }-->
<!--   .el-message-box__content {-->
<!--     font-size: 3vw;-->
<!--     line-height: 3vw;-->
<!--     width: 100%; /* 确保内容区域有足够宽度 */-->
<!--     overflow-wrap: break-word; /* 允许在长单词或URL内部进行换行 */-->
<!--   }-->

<!--   .el-button&#45;&#45;mini, .el-button&#45;&#45;small {-->
<!--     font-size: 3.5vw;-->
<!--   }-->

<!--   .el-message-box__message p {-->
<!--     line-height: 4.5vw;-->
<!--   }-->
<!--</style>-->




// WEBPACK FOOTER //
// src/components/mobileDetailed.vue